import * as Yup from 'yup'
import { FormItemProps } from '@/components/Form/types'
import getLaserProfiles from '@/services/ProductService/getLaserProfiles'
import getHatchProfiles from '@/services/ProductService/getHatchProfiles'


const items: Array<FormItemProps> = [


	{
		name: 'center_section_to_field',
		label: 'Center Section To Field',
		help: 'Keep the section centered in the machine field when the engraving job is prepared.',
		placeholder: 'Angle',
		type: 'Checkbox',
		classNames: {container: 'col-span-12'},
		defaultValue: true,
	},

	{
		name: 'maintain_aspect_ratio',
		label: 'Maintain Aspect Ratio',
		help: 'Preserve the artwork proportions when it is resized to fit the engraving section.',
		type: 'Checkbox',
		classNames: {container: 'col-span-12'},
		defaultValue: true,
	},

	{
		name: 'horizontal_ratio_percentage',
		label: 'Keystone Ratio correction',
		help: 'Apply a horizontal percentage correction to compensate for keystone distortion in the engraving field.',
		placeholder: 'Horizontal',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '0',
		validation: Yup.string().required('Required'),
	},
	{
		name: 'vertical_ratio_percentage',
		label: 'vertical_ratio_percentage',
		help: 'Apply a vertical percentage correction to compensate for keystone distortion in the engraving field.',
		placeholder: 'Vertical',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: '0',
		validation: Yup.string().required('Required'),
	},
	{
		name: 'outline_laser_profile_id',
		label: 'Outline Laser Profile Name',
		help: 'Select the laser profile that controls how the outline of artwork in this section is marked.',
		type: 'Select',
		itemOptions: {
			fetch: async () => {
				const list = await getLaserProfiles() || []
				return list.map((item) => ({
					data: item,
					label: item?.name,
					value: item?.id,
				}))
			}
		},
		classNames: {container: 'col-span-12'},
		defaultValue: null,
		validation: Yup.string().required('Laser Profile is required'),
	},
	{
		name: 'hatch_profile_ids',
		label: 'Hatch Profile Name',
		help: 'Select one or more hatch profiles that control how filled areas of artwork in this section are marked.',
		type: 'Select',
		itemOptions: {
			fetch: async () => {
				const list = await getHatchProfiles() || []
				return list.map((item) => ({
					data: item,
					label: item?.name,
					value: item?.id,
				}))
			},
			features :{
				isMulti: true,
			},
		},
		classNames: {container: 'col-span-12'},
		defaultValue: null,
		validation: Yup.array().required('Hatch Profile is required'),
	},

	{
		name: 'marking_order',
		label: 'Marking Order',
		help: 'Choose whether the job marks hatch areas, outlines, or both, and set which operation runs first.',
		type: 'Select',
		itemOptions: {
			list: [
				{ label: 'Hatch Only', value: 'hatch_only' },
				{ label: 'Outline Only', value: 'outline_only' },
				{ label: 'Hatch Before Outline', value: 'hatch_before_outline' },
				{ label: 'Outline Before Hatch', value: 'outline_before_hatch' },
			]
		},
		classNames: {container: 'col-span-4'},
		defaultValue: {value: 'hatch_only'},
		validation: Yup.string().required('Marking order is required'),
	},
	{
		name: 'preview_mark_type',
		label: 'Preview Mark Type',
		help: 'Choose the boundary the machine traces when previewing the section position before marking.',
		type: 'Select',
		itemOptions: {
			list: [
				{ label: 'Outline', value: 'outline' },
				{ label: 'Tight Boundary', value: 'tight_boundary' },
				{ label: 'Bounding Box', value: 'bounding_box' },
				{ label: 'Off', value: 'off' },
			]
		},
		classNames: {container: 'col-span-4'},
		defaultValue: {value: 'tight_boundary'},
		validation: Yup.string().required('Mark type is required'),
	},
	{
		name: 'preview_mark_speed',
		label: 'Preview Mark Speed',
		help: 'Set the movement speed used when the machine traces the selected preview boundary.',
		placeholder: 'Speed',
		type: 'Number',
		classNames: {container: 'col-span-4'},
		defaultValue: 5000,
		validation: Yup.string().required('Preview mark speed is required'),
	},
]





export default items
